import { tblSpecAddColumn } from '../../../core/table/spec';
import { TblCol } from '../../../core/table/table.types';
import { TblViewSpec } from '../../../core/table/table-view.types';
import FormattedDateRenderer from '../../../core/table/renderers/FormattedDateRenderer';

export type DispensesColKey =
    | ''
    | 'CEID'
    | 'PHID'
    | 'TransId'
    | 'DispNdc'
    | 'DispDate'
    | 'PhysicianName'
    | 'PatientNumber'
    | 'DispQuantity'
    | 'BackingQuantity';

export function splitInvoiceLineItemDispensesColumnSpec(): Map<string, TblCol> {
    const map = new Map<DispensesColKey, TblCol>();
    tblSpecAddColumn<DispensesColKey>(map, 'CEID', { title: 'Facility', type: 'TEXT' });
    tblSpecAddColumn<DispensesColKey>(map, 'PHID', { title: 'Pharmacy', type: 'TEXT' });
    tblSpecAddColumn<DispensesColKey>(map, 'TransId', { title: 'Transaction Id', type: 'TEXT' });
    tblSpecAddColumn<DispensesColKey>(map, 'DispNdc', { title: 'NDC', type: 'TEXT' });
    tblSpecAddColumn<DispensesColKey>(map, 'DispDate', { title: 'Date Filled', type: 'DATE' }, FormattedDateRenderer);
    tblSpecAddColumn<DispensesColKey>(map, 'PhysicianName', { title: 'Physician', type: 'TEXT' });
    tblSpecAddColumn<DispensesColKey>(map, 'PatientNumber', { title: 'Patient Id', type: 'TEXT' });
    tblSpecAddColumn<DispensesColKey>(map, 'DispQuantity', { title: 'Dispensed', type: 'TEXT' });
    tblSpecAddColumn<DispensesColKey>(map, 'BackingQuantity', { title: 'Used', type: 'TEXT' });
    return map;
}

export function splitInvoiceLineItemDispensesAllColumnsView(): TblViewSpec {
    return {
        key: 'all',
        title: 'All Columns',
        sections: [
            { title: 'Location', cols: ['CEID', 'PHID'] },
            { title: 'Dispense Info', cols: ['TransId', 'DispNdc', 'DispDate', 'PhysicianName', 'PatientNumber'] },
            { title: 'Quantity', cols: ['DispQuantity', 'BackingQuantity'] },
        ],
        sortby: 'DispDate',
    };
}
